import type { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const treeChartDescription: CalculatorDescription = {
  id: CalculatorId.TreeChart,
  title: 'Tree Diagram Maker',
  metaTitle: 'Online Tree Diagram Maker - Create Tree Charts',
  description: 'Create professional tree diagrams to visualize hierarchical relationships and organizational structures. Perfect for displaying family trees, org charts, and decision trees.',
  metaDescription: 'Make professional tree diagrams online. Visualize hierarchical data with our free tree chart generator. Perfect for org charts, family trees, and decision trees.',
  howTo: {
    title: 'How to Create a Tree Diagram',
    steps: [
      'Enter hierarchical data with category paths (e.g., Parent/Child/Grandchild)',
      'Choose orientation (horizontal or vertical)',
      'Configure label display options',
      'Add values for node sizing (optional)',
      'Set title and finalize visualization'
    ],
    graphic: {
      description: 'An echarts tree diagram with interactive nodes, customizable orientation, and hierarchical data display'
    }
  },
  examples: [
    {
      title: 'Organization Chart',
      description: 'Company structure visualization',
      dataDescription: 'Department and team hierarchy with employee counts',
      insights: [
        'Visualize reporting lines',
        'Show team sizes',
        'Display department structure',
        'Track organizational depth'
      ]
    },
    {
      title: 'Project Dependencies',
      description: 'Software component relationships',
      dataDescription: 'Module dependencies and relationships',
      insights: [
        'Show dependency chains',
        'Identify root components',
        'Track module relationships',
        'Visualize code structure'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.SunburstChart,
    CalculatorId.NightingaleChart,
    CalculatorId.PieChart,
    CalculatorId.BarGraph
  ]
}; 